module.exports = __webpack_public_path__ + "img/shareef-a.0867f189.jpg";